var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgLoop = function SvgLoop(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 11q0-2.925 2.037-4.962T9 4h6q2.925 0 4.962 2.037T22 11q0 2.575-1.65 4.525t-4.2 2.375a.98.98 0 0 1-.8-.2.85.85 0 0 1-.35-.7q0-.425.338-.725.337-.3.787-.4 1.725-.4 2.8-1.762A4.9 4.9 0 0 0 20 11q0-2.075-1.462-3.537Q17.074 6 15 6H9Q6.925 6 5.463 7.463 4 8.925 4 11t1.463 3.537T9 16h.175l-.9-.9A.93.93 0 0 1 8 14.413q0-.414.3-.713a.95.95 0 0 1 .7-.275q.425 0 .7.275l2.6 2.6q.3.3.3.7t-.3.7l-2.6 2.6a.93.93 0 0 1-.687.275q-.413 0-.713-.275-.3-.3-.3-.713 0-.412.3-.712L9.175 18H9q-2.925 0-4.962-2.037T2 11"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLoop);
export { ForwardRef as ReactComponent };